import type { AnchorHTMLAttributes, FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'

interface SectionLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    hash: string
    children: ReactNode
}

/**
 * Links to a section of the home page. On the home page it stays a plain in-page anchor
 * (smooth-scrolled by SmoothScroll); elsewhere it navigates client-side to /#hash.
 */
export const SectionLink: FC<SectionLinkProps> = ({ hash, children, ...rest }) => {
    const { pathname } = useRouter()

    if (pathname === '/') {
        return (
            <a href={`#${hash}`} {...rest}>
                {children}
            </a>
        )
    }

    return (
        <Link href={`/#${hash}`} {...rest}>
            {children}
        </Link>
    )
}
